import { isEngineOilCategory } from "./partCategoryOptions.js";

export const PRODUCT_LIST_FALLBACK = "/";

const decodeSafely = (value) => {
  let decoded = String(value || "").trim();
  for (let i = 0; i < 5; i += 1) {
    try {
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    } catch {
      return null;
    }
  }
  return decoded;
};

export const sanitizeReturnTo = (value) => {
  const decoded = decodeSafely(value);
  if (!decoded || !decoded.startsWith("/") || decoded.startsWith("//")) return null;
  if (/^[^?#]*:\/\//i.test(decoded) || /(?:^|[?&])returnTo=/i.test(decoded)) return null;

  let url;
  try {
    url = new URL(decoded, "https://www.kccparts.ca");
  } catch {
    return null;
  }
  if (url.origin !== "https://www.kccparts.ca") return null;

  // A product page is never a useful place to accumulate browsing history.
  if (url.pathname.startsWith("/product/")) return url.pathname;
  url.searchParams.delete("returnTo");
  return `${url.pathname}${url.search}${url.hash}`;
};

export const isSafeInternalPath = (path) => {
  const sanitized = sanitizeReturnTo(path);
  if (!sanitized) return false;

  return (
    sanitized === "/" ||
    sanitized.startsWith("/browse") ||
    sanitized.startsWith("/results") ||
    sanitized.startsWith("/search") ||
    sanitized.startsWith("/category/") ||
    sanitized.startsWith("/products") ||
    sanitized.startsWith("/engine-oil") ||
    sanitized.startsWith("/page") ||
    sanitized.startsWith("/home") ||
    sanitized.startsWith("/vehicles") ||
    sanitized.startsWith("/cart") ||
    sanitized.startsWith("/order/") ||
    sanitized.startsWith("/placeorder") ||
    sanitized.startsWith("/guest-placeorder") ||
    sanitized.startsWith("/product/")
  );
};

export const getCurrentRoute = (location) => {
  if (location?.pathname?.startsWith("/product/")) {
    const returnTo = sanitizeReturnTo(new URLSearchParams(location.search || "").get("returnTo"));
    const stateFrom = sanitizeReturnTo(location.state?.from);
    return (returnTo && !returnTo.startsWith("/product/") && returnTo) ||
      (stateFrom && !stateFrom.startsWith("/product/") && stateFrom) ||
      PRODUCT_LIST_FALLBACK;
  }
  const route = `${location?.pathname || ""}${location?.search || ""}`;
  const sanitized = sanitizeReturnTo(route);
  return sanitized && isSafeInternalPath(sanitized) ? sanitized : PRODUCT_LIST_FALLBACK;
};

export const buildProductUrl = (productId) => `/product/${encodeURIComponent(String(productId))}`;

export const getProductBackDestination = (location, product) => {
  const returnTo = sanitizeReturnTo(new URLSearchParams(location.search || '').get('returnTo'));
  if (isSafeInternalPath(returnTo)) return returnTo;
  const stateFrom = sanitizeReturnTo(location.state?.from);
  if (isSafeInternalPath(stateFrom)) return stateFrom;
  return isEngineOilCategory(product?.category) ? '/engine-oil' : PRODUCT_LIST_FALLBACK;
};
